<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: "public-layout"
  }
</script>

<style scoped>

</style>